import {
	Box,
	Text,
	VStack,
	Grid,
	GridItem,
	List,
	Stack,
	For,
} from '@chakra-ui/react';
import React from 'react';

import { Display } from '@/modules/shared/presentation';

import { useJobDetailContext } from './JobDetail';

export const JobDetailHowToApply = () => {
	const { job } = useJobDetailContext();

	return (
		<>
			<Display.Root>
				<Display.Header
					bg="primary.50"
					color="primary.100"
					textAlign="center"
				>
					How to Apply
				</Display.Header>
				<Display.Content p={0}>
					<VStack
						align="stretch"
						bg="white"
						gap={6}
						px={6}
						py={5}
					>
						<VStack align="stretch" gap={3}>
							<Text fontWeight="semibold">
								Click the "Entry" button on this page and enter the required information to apply
							</Text>
							<List.Root ml="md">
								<List.Item>Please note that application documents will not be returned.</List.Item>
								<List.Item>Personal information provided will be used only for recruitment activities and will not be  disclosed or provided to third parties.</List.Item>
								<List.Item>Job information will be deleted from the site once the posting period has expired.</List.Item>
								<List.Item>If you would like to check the details of the job you applied for, please take measures such as printing this page.</List.Item>
							</List.Root>
						</VStack>

						<Stack>
							<Text
								bg="primary.50"
								color="primary.100"
								px={4}
								py={2}
								rounded="sm"
								textStyle="bodyBold"
							>
								Step flows until join company
							</Text>
						</Stack>
						<For each={job.howToApply.applicationSteps}>
							{step => (
								<Stack key={step.stepNumber}>
									<Text>
										{`Step ${step.stepNumber}: ${step.description}`}
									</Text>
								</Stack>
							)}
						</For>
						<Text>
							{job.howToApply.applicationInstructions}
						</Text>

						<Box>
							<Text
								bg="primary.50"
								color="primary.100"
								px={4}
								py={2}
								rounded="sm"
								textStyle="bodyBold"
							>
								Contact
							</Text>
							<Grid
								border="1px solid #EDF2F7"
								gap={0}
								mt={4}
								templateColumns={{
									base: '1fr',
									md:   '220px 1fr',
								}}
							>
								<GridItem bg="#F7FAFC" p={3}>
									<Text>Company</Text>
								</GridItem>
								<GridItem bg="white" p={3}>
									<Text>
										{job.company.name}
									</Text>
								</GridItem>
								<GridItem bg="#F7FAFC" p={3}>
									<Text>Website</Text>
								</GridItem>
								<GridItem bg="white" p={3}>
									<Text color="blue.600">
										{job.company.corporateWebsite ?? '-'}
									</Text>
								</GridItem>
								<GridItem bg="#F7FAFC" p={3}>
									<Text>Office</Text>
								</GridItem>
								<GridItem bg="white" p={3}>
									<Text>
										{job.company.mainOffice ?? '-'}
									</Text>
								</GridItem>
							</Grid>
						</Box>
					</VStack>
				</Display.Content>
			</Display.Root>
		</>
	);
};
